$(() => {
  $(".open-social-modal").on("click", function (e) {
    e.preventDefault();
    $(".social-modal-container").css("display", "flex").hide().fadeIn();
  });
  $(".social-modal-container .close").on("click", function (e) {
    e.preventDefault();
    $(".social-modal-container").fadeOut();
  });
  $(".social-modal-container").on("click", function (e) {
    e.preventDefault();
    $(".social-modal-container").fadeOut();
  });
  $(".social-modal").on("click", function (e) {
    e.stopPropagation();
  });
});
